<template>
  <div class="page">
    <Tabs @selected="handleSelectedTab" module="products" />

    <div class="page-main" v-if="selectedTab">
      <div class="page-wrapper">
        <div class="page-controls">
          <h4>{{ selectedTab.name }}</h4>
          <div class="d-flex">
            <ActionButton
              v-if="selectedTab.id === 0"
              label="Linked Products"
              :theme="{ primary, secondary, event, danger }"
              style="display: inline-block; width: auto; margin-top: 0; font-size: 0.75rem; margin-right: 1rem;"
              mode="outline"
              @customEvent="handleLinkedProducts"
            />
            <ActionButton
              :label="'Add ' + selectedTab.singular"
              :theme="{ primary, secondary, event, danger }"
              style="display: inline-block; width: auto; margin-top: 0; font-size: 0.75rem;"
              @customEvent="handleAdd"
            />
          </div>
        </div>

        <!-- Package -->
        <Products
          v-if="selectedTab.id === 0"
          key="dt-packages"
          @edit="handleEdit"
        />

        <!-- Category -->
        <Categories
          v-if="selectedTab.id === 1"
          key="dt-category"
          @edit="handleEdit"
        />

        <!-- Locations -->
        <Locations
          v-if="selectedTab.id === 3"
          key="dt-locations"
          @edit="handleEdit"
        />

        <!-- Inclusions -->
        <Inclusions
          v-if="selectedTab.id === 4"
          key="dt-inclusions"
          @edit="handleEdit"
        />

        <!-- Terms -->
        <Terms v-if="selectedTab.id === 5" key="dt-terms" @edit="handleEdit" />

        <!-- Schedule -->
        <Schedule
          v-if="selectedTab.id === 6"
          key="dt-schedule"
          @edit="handleEdit"
        />
      </div>
    </div>
  </div>
</template>

<script>
const ActionButton = () => import("@/components/ActionButton");
const Products = () => import("../components/manage-products/Products");
const Categories = () => import("../components/manage-products/Categories");
const Locations = () => import("../components/manage-products/Locations");
const Inclusions = () => import("../components/manage-products/Inclusions");
const Terms = () => import("../components/manage-products/Terms");
const Schedule = () => import("../components/manage-products/Schedule");
const Tabs = () => import("../components/Tabs");

export default {
  name: "admin-products",
  components: {
    ActionButton,
    Products,
    Categories,
    Locations,
    Inclusions,
    Terms,
    Schedule,
    Tabs
  },
  data: () => ({
    selectedTab: null
  }),
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  },
  methods: {
    handleSelectedTab(tab) {
      this.isLoading = true;
      this.selectedTab = tab;
    },
    handleAdd() {
      this.$emit("showModal", {
        ...this.selectedTab.modalParams,
        name: this.selectedTab.modalName,
        hasBackdropEvent: false
      });
    },
    handleLinkedProducts() {
      this.$emit("showModal", {
        name: "linked-products",
        hasBackdropEvent: false
      });
    },
    handleEdit(item) {
      this.$emit("showModal", {
        name: this.selectedTab.modalName.replace("add", "edit"),
        hasBackdropEvent: false,
        ...item
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.page {
  padding: 0 15px;
  &-controls {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  &-main {
    height: calc(100vh - 245px);
    overflow-x: hidden;
    overflow-y: auto;
    background-color: $gray-50;
    margin-top: 20px;
    margin-bottom: 40px;
    padding: 20px 30px 0;
  }
  &-wrapper {
    margin-bottom: 40px;
    h4 {
      color: $gray-900;
      font-family: "Gotham";
      font-weight: 500;
      font-size: $font-size-xs;
      margin-bottom: 0;
    }
    button {
      line-height: 16px;
    }
  }
}
</style>
